<ngx-spinner bdColor="rgba(115,38,114,0)" size="medium" color="#732672" type="ball-atom" [fullScreen]="true"><p style="color: #732672"> Cargando... </p></ngx-spinner>
<div class="container mt-3 mb-3">
  <div class="row border-bottom: 5px solid #732672;" style="">
    <div class="col">
      <img alt="" class="img-fluid" src="assets/img/LogoFdlm.fw.png" />
    </div>
    <div class="col justify-content-md-center" style="display: flex; align-items: center;">
      <div style="font-size: 1vw;color: #e18023">
        {{ usuario.nombre }}
      </div>
    </div>
    <div class="col justify-content-md-center" style="display: flex;align-items: baseline;">
      <div class="row">
        <div class="col">
          <div class="row">
            <span style="font-size: 1vw;color: #e18023">Carpeta Digital</span>
          </div>
          <div class="row">
            <a *ngIf="usuario" (click)="logout()">
              <spam style="font-size: 1vw;color: #e18023">Cerrar sesion</spam>
              <img alt="" class="img-fluid" src="assets/img/Salida.fw.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div>
      <!--(ngSubmit)="consSolicitud()"-->
      <form [formGroup]="consSolForm">
        <mat-form-field>
          <input type="text" formControlName="numSolicitud" matInput placeholder="Número solicitud" />
        </mat-form-field>
        <input type="image" src="assets/img/lupa.png" border="0" alt="submit" [disabled]="!(consSolForm.valid && NoClick)" (click)="consSolicitudClick($event);" />
      </form>
    </div>
    <div *ngIf="((varIdPerfil!==0) && (varNumSolicitud))">
      <div>
        <cabezote [varNumSolicitud]="varNumSolicitud" ></cabezote>
      </div>
      <div *ngIf="((selDocu) && (varNumSolicitud))">
        <br />
        <documentosSeparador [varNumSolicitud]="varNumSolicitud" [varIdPerfil]="varIdPerfil" (subirArchivoButton)="subirArchivo()"
                             (evtVistaPrevia)="MostrarVisor($event)" (evtVisPreSonido)="VisPreSonido($event)" ></documentosSeparador>
        <br />
      </div>
      <div *ngIf="((selImportar) && (varNumSolicitud))">
        <br />
        <importador [varNumSolicitud]="varNumSolicitud" (cancelarImportarButton)="cancelarImportar()" (finalizaImportacionEvent)="finalizarImportar()"></importador>
        <br />
      </div>
      <div *ngIf="selVisor">
        <br />
        <div class="row" style="margin-bottom: 5px;">
          <div class="col-10">
            <ng-template [ngIf]="true">
              <p>{{ selDocumento.StrTipoDocumento }}</p>
            </ng-template>
              <!--
    <select id="Documento" name="Documento"  >
      <option [value]="DocSol.tmpIdCabVer" *ngFor="let DocSol of lstDocs | async">{{DocSol.StrInfoDocumento}}</option>
    </select>
    -->
          </div>
          <div class="col-2 text-right">
            <button type="button" class="btn btn-primary" (click)="CerrarVisor()">Cerrar</button>
          </div>
        </div>
        <visorPdf [varDocumento]="selDocumento"> </visorPdf>
        <div class="row" style="margin: 5px;">
          <div class="col text-center">
            <input type="button" class="btn btn-primary" (click)="AntDoc()" value="Anterior" />
          </div>
          <div class="col text-center">
            <input type="button" class="btn btn-primary" (click)="SigDoc()" value="Siguiente" />
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="verMsgPermiso">
      <br />
      <br />
      <br />
      <br />
      <div align="center">
        <p>{{ msgMensaje }}</p>
      </div>
    </div>
  </div>
  <div style="border-top: 5px solid #732672; ">
    <div class="row mt-3" >
      <div class="col float-lg-left">
        <img alt="" class="img-fluid" src="assets/img/LogoInfopoint.fw.png" />
      </div>
      <div class="col">

      </div>
      <div class="col text-right">
        <a href="http://www.imglatam.com/web/wInicio.aspx" target="_blank">
          <img alt="" class="img-fluid" src="assets/img/LogoIMG.fw.png" />
        </a>
      </div>
    </div>
    <div class="float-lg-left">
      <p style="font-size: 0.8vw;color:#732672">Versión: {{appVersion}}</p>
    </div>
  </div>
</div>
